<template>
    <div class="global-address-administration__list-view">
        <h3 v-if="$t('labels.addresses')">{{ $t('labels.addresses') }}</h3>
        <div class="row">
            <div class="col-12 col-md-6 col-lg-4" v-if="key + 1 >= start && key + 1 <= end" :key="key" v-for="(address, key) in addresses">
                <template v-if="address.mainAddress">
                    <global-address :address="address">
                        <template slot="side-actions">
                            <global-button icon="trash" theme="ghost" disabled />
                            <global-button icon="edit" theme="ghost" disabled />
                        </template>

                        <global-button slot="actions" @click="selectAddress(address.index)">{{ $t('labels.select') }}</global-button>
                    </global-address>
                </template>
                <template v-else>
                    <global-address :address="address">
                        <template slot="side-actions">
                            <global-button icon="trash" theme="ghost" @click="deleteAddress(address.index)" />
                            <global-button icon="edit" theme="ghost" @click="editAddress(address.index)" />
                        </template>

                        <global-button slot="actions" @click="selectAddress(address.index)">{{ $t('labels.select') }}</global-button>
                    </global-address>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
import GlobalButton from "@global/global-elements/global-button/global-button";
import GlobalAddress from "@global/global-elements/global-address/global-address";

export default {
    name: "global-address-administration-list",
    props: ["addresses", "start", "end"],
    components: { GlobalButton, GlobalAddress },
    methods: {
        editAddress(key) {
            this.$emit('edit', {detail: key})
        },
        deleteAddress(key) {
            this.$emit('delete', {detail: key})
        },
        selectAddress(key) {
            this.$emit('select', {detail: key})
        }
    },
}
</script>
